import { createStyle } from '~/hooks';
import { Components } from '~/utils/components-list';

export const styles = createStyle(Components.Dropdown, {
  root: {},
  trigger: {},
  menu: {},
  menuItem: {},
});
